import InstantMessagePresenceType from 'owa-service/lib/contract/InstantMessagePresenceType';
import { PersonaPresence } from 'office-ui-fabric-react/lib/Persona';
import { addOrUpdatePresence } from '../actions/presenceActions';

export default function updateUserPresence(
    sipUrl: string,
    newUserPresence: InstantMessagePresenceType
) {
    const personaPresence = getPersonaPresenceFromInstantMessagePresenceType(newUserPresence);
    addOrUpdatePresence(sipUrl, personaPresence);
}

function getPersonaPresenceFromInstantMessagePresenceType(
    presence: InstantMessagePresenceType
): PersonaPresence {
    if (presence == 'Offline') {
        return PersonaPresence.offline;
    }

    if (presence == 'Away' || presence == 'BeRightBack') {
        return PersonaPresence.away;
    }

    if (presence == 'Busy' || presence == 'IdleBusy') {
        return PersonaPresence.busy;
    }

    if (presence == 'DoNotDisturb') {
        return PersonaPresence.dnd;
    }

    if (presence == 'Online' || presence == 'IdleOnline') {
        return PersonaPresence.online;
    }

    return PersonaPresence.none;
}
